export enum BatteryTypeRef {
  lithium_ion_nmc = "lithium_ion_nmc",
  lithium_ion_lfp = "lithium_ion_lfp",
  carbon_lead_acid = "carbon_lead_acid",
  lead_acid = "lead_acid"
  }